import DatePicker from "react-multi-date-picker";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledToobar = styled(Toolbar)`
  & div:nth-child(2) {
    display: none;
  }
  & div {
    flex-grow: 1;
    margin: 3px 5px;
  }
`;
export const StyledDatePicker = styled(DatePicker)`
  & .rmdp-toolbar > div {
    background-color: ${theme.palette.primary.main} !important;
  }

  & .rmdp-selected .sd {
    background-color: ${theme.palette.primary.main} !important;
  }

  & .rmdp-day .sd {
    &:hover {
      background-color: ${theme.palette.primary.light}90 !important;
    }
  }

  & .rmdp-today .sd {
    background-color: ${theme.palette.primary.main}99 !important;
  }

  & .rmdp-selected.rmdp-today .sd {
    background-color: ${theme.palette.primary.main} !important;
  }

  & .rmdp-selected. > span {
    color: ${theme.palette.primary.contrastText} !important;
  }

  & .rmdp-panel-body li {
    background-color: ${theme.palette.primary.main} !important;
  }

  & .rmdp-week .rmdp-week-day {
    color: ${theme.palette.primary.main} !important;
  }

  & .rmdp-arrow-container .rmdp-arrow {
    border-color: ${theme.palette.primary.main} !important;
  }
  & .rmdp-arrow-container {
    &:hover {
      background-color: ${theme.palette.primary.main} !important;
      padding-top: 2px;
      & .rmdp-arrow {
        border-color: ${theme.palette.primary.contrastText} !important;
      }
    }
  }

  & .dial-lines {
    background-color: ${theme.palette.primary.dark} !important;
  }

  & .rmdp-analog-clock {
    background-color: ${theme.palette.primary.light} !important;
    border-color: ${theme.palette.primary.main} !important;

    & [class*="rmdp-h"] {
      color: ${theme.palette.primary.contrastText} !important;
    }

    & .rmdp-hour,
    .rmdp-minute {
      margin-top: -5px !important;
    }
  }
  & .rmdp-analog-clock > div:nth-child(2) {
    margin-top: -5px !important;
  }
`;
